module.exports = __webpack_public_path__ + "static/img/rencai.d4d14ed.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rencai.jpg
// module id = ANTH
// module chunks = 13